import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=bc653cfa&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=bc653cfa&prod&scoped=true&lang=css&"
import style1 from "./edit.vue?vue&type=style&index=1&id=bc653cfa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc653cfa",
  null
  
)

export default component.exports